"use client";

import "./OperationSection.scss";
import InteractiveFeatureSection from "@/components/InteractiveFeatureSection/InteractiveFeatureSection";

const OperationSection = ({ operation }) => {
  if (!operation) return null;

  const { title, description, features = [] } = operation;

  return (
    <InteractiveFeatureSection
      title={title}
      description={description}
      features={features}
      sectionClass="operation-section"
    />
  );
};

export default OperationSection;
